module.exports = __webpack_public_path__ + "img/03880_1.prt.1a92bf54.jpg";